import { render, staticRenderFns } from "./EventProductSidebar.vue?vue&type=template&id=3808cb36&scoped=true&"
import script from "./EventProductSidebar.vue?vue&type=script&lang=js&"
export * from "./EventProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EventProductSidebar.vue?vue&type=style&index=0&id=3808cb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3808cb36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3808cb36')) {
      api.createRecord('3808cb36', component.options)
    } else {
      api.reload('3808cb36', component.options)
    }
    module.hot.accept("./EventProductSidebar.vue?vue&type=template&id=3808cb36&scoped=true&", function () {
      api.rerender('3808cb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/event/components/EventProductSidebar.vue"
export default component.exports